export const getMTODeliveryDate = (createdAt?: string, daysToAdd = 21) => {
  const baseDate = createdAt ? new Date(createdAt) : new Date()
  const deliveryDate = new Date(baseDate)

  deliveryDate.setDate(baseDate.getDate() + daysToAdd)

  return deliveryDate.toLocaleDateString('en-GB', {
    month: 'long',
    day: 'numeric'
  })
}

export const isMtoProduct = (tags: string | undefined) => {
  return !!tags && tags.includes('tax:MTO')
}

export const isBundleProduct = (bundleName: string | undefined) => {
  return !!bundleName?.trim()
}
